import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'load-more',
  template: `
  <div *ngIf="isFeaturedProductIncludedInCount ? ((page * limit) + 1) < totalProducts : (page * limit) < totalProducts" class="load-more-container">
		<input type="button" class="buy-link load-more-btn cta-link-large" value="{{ 'load_more' | translate }}" (click)="loadMore($event)" />
  </div>

  <div class='legalinfo' *ngIf="locale==='en-us' ||locale==='en-gb' || locale==='de-de' ||locale==='fr-fr'||locale==='fr-ca' || locale==='en-ca' || locale==='pl-pl' || locale==='es-es' || locale==='nl-nl' || locale==='it-it' || locale==='zh-tw'" >{{'msrp_note' | translate}}</div>
  `
})
export class LoadMoreComponent implements OnInit {
  @Input() page: number;
  @Input() limit: number;
  @Input() totalProducts: number;
  @Input() isFeaturedProductIncludedInCount: boolean;
  @Input() locale : string;
  @Output() onPaging = new EventEmitter();

  constructor() {

  }

  ngOnInit() {

  }

  loadMore(event) {
    event.preventDefault();
    this.onPaging.emit({
      value: {
        page: +this.page + 1
      }
    });
    window["hatchwidgetHelpers"].nvbuyinit();
    event.target.blur();
  }

}
